import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DictionaryRequestType } from 'src/app/extensions/constants/dictionaryConstants/dictionaryConstants';
import { DictionaryAPIService } from 'src/app/extensions/services/api/dictionary-api.service';

@Component({
  selector: 'app-request-entry',
  templateUrl: './request-entry.component.html',
  styleUrls: ['./request-entry.component.scss'],
  standalone: false,
})
export class RequestEntryComponent implements OnInit {
  dictionaryRequestTypes: app.models.DictionaryRequestType[] = [];
  @Input() redirect: boolean = false;
  @Input() requestAccessWarnings: string[] = [];
  selectedOption: string | undefined;

  RequestType = DictionaryRequestType;

  constructor(
    private _router: Router,
    private _dictionaryAPIService: DictionaryAPIService,
    public _activeModal: NgbActiveModal
  ) {}

  ngOnInit(): void {
    this._dictionaryAPIService.getDictionaryRequestType().subscribe(result => {
      this.dictionaryRequestTypes = result;
      if (this.redirect) {
        this.dictionaryRequestTypes = this.dictionaryRequestTypes.filter(
          x => x.dictionaryRequestTypeCode != DictionaryRequestType.RQST_CLIENT_DATA
        );
      }
    });
  }

  redirectRoute(route: string, requestType: string) {
    if (requestType === DictionaryRequestType.RQST_ASSET_DOCUMENT && this.requestAccessWarnings.length > 0) {
      return;
    }

    if (this.redirect) {
      this.selectedOption = route;
      return;
    }

    this._router.navigate([route]);
  }

  closeModal(option: string | null = null) {
    this._activeModal.close(option);
  }
}
